import request from "../utils/request";

export const getReturnOrderList = '/return/'

export function getReturnOrderDetail(orderId: number) {
    return request.request({
        method: "get",
        url: "/return/detail",
        params: {orderId: orderId}
    })
}

export function updateReturnOrderContacted(orderId: number) {
    return request.request({
        method: "get",
        url: '/return/contacted',
        params: {orderId: orderId}
    })
}